"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var Number_js_1 = require("./fn/Number.js");
var String_js_1 = require("./fn/String.js");
var Date_js_1 = require("./fn/Date.js");
// 为了common导出随处可用的js
exports.$fn = __assign({}, Number_js_1.default, String_js_1.default, Date_js_1.default);
// 供import导入使用
exports.default = exports.$fn;
//# sourceMappingURL=index.js.map